import React from 'react';

const Banner = () => {
    return (
        <div>
            <div>
                <img src="https://i.ibb.co/M7s5bKK/carl-nenzen-loven-ig-Kjieyjcko-unsplash.jpg" className="img-fluid" alt="" />
            </div>
        </div>
    );
};

export default Banner;